module.exports = __webpack_public_path__ + "static/media/3-0.de9a7f40.jpg";